import { put } from "redux-saga/effects";

import { TOPICS_FOR_COLLECTION_LIMIT } from "common/constants/limit";
import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { fetchCollectionForViewingFailure, fetchCollectionForViewingSuccess } from "domains/collection/actions";
import type { FetchCollectionForViewingAction } from "domains/collection/actionTypes";
import type { CollectionViewResponse } from "domains/collection/types/collectionResponses";
import { fetchTopicsForCollection } from "entities/topics/actions";

export function* fetchCollectionForViewingSaga({ id }: FetchCollectionForViewingAction) {
  try {
    yield put(fetchTopicsForCollection({ id, limit: TOPICS_FOR_COLLECTION_LIMIT, offset: 0 }));

    const response: CollectionViewResponse = yield apiFetch(`collection/${id}`);
    yield put(fetchCollectionForViewingSuccess(response));
  } catch (error) {
    logger.error(`[fetchCollectionForViewingSaga] Failed to fetch collection with ID '${id}'`, error);
    yield put(fetchCollectionForViewingFailure(id));
  }
}
